import { useCallback } from 'react';
import HubSpotVideoPicker from 'media-bridge-lib/components/media-picker/HubSpotVideoPicker';
import { PanelTypes, VideoPanelState } from '../state/videoPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export const VideoPickerIframe = ({
  isActive,
  onSelect,
  onClose,
  shouldEncodeToHlsOnInsert
}) => {
  const handleClickDetails = useCallback(video => {
    VideoPanelState.setState(draft => {
      draft.state.DETAILS.fileId = video.sourceFileId;
      draft.activePanel = PanelTypes.DETAILS;
    });
  }, []);
  const handleSelect = useCallback(video => {
    onSelect(video);
  }, [onSelect]);
  if (!isActive) {
    return null;
  }
  const allowNonHlsVideoEmbeds = !shouldEncodeToHlsOnInsert;
  return /*#__PURE__*/_jsx(HubSpotVideoPicker, {
    allowNonHlsVideoEmbeds: allowNonHlsVideoEmbeds,
    showNonEmbeddable: true,
    onSelect: handleSelect,
    onClickDetails: handleClickDetails,
    onClose: onClose
  });
};